import templateUrl from './edit-product.component.html';

export const EditProductComponent = {
    controller: NewProductController,
    controllerAs: "vm",
    bindings: {
        product: "<",
        afterSubmit: "&"
    },
    templateUrl
}

function NewProductController(utilityService, productsService, divisionService, productLinesService) {
    'ngInject';
    const vm = this;
    vm.afterSubmit;
    vm.editForm;
    vm.onSubmit = onSubmit;
    vm.$onInit = activate;
    vm.errorMsg;
    vm.product;
    vm.divisionList;
    vm.onChangeDivision = onChangeDivision;
    vm.onChangeProductLine = onChangeProductLine;
    vm.selectedDivision;
    vm.value;
    vm.productLines;

    function activate() {
        utilityService.showLoading();
        divisionService.retrieveDivisions()
            .then(function (divisions) {
                vm.divisionList = divisions.filter(function (event) {
                    return event.UseProductCommissionPolicy

                });
                if (vm.product) {
                    vm.product.sDivisionID = vm.product.DivisionID
                }
            }).then(productLinesService.retrieveProductLines)
            .then(function (productLines) {
                vm.productLines = productLines;
            }).then(filterProductLines)
            .catch(function (ex) {
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                utilityService.hideLoading();
            });

    }
    function filterProductLines() {

        if (vm.product) {
            vm.productLineList = vm.productLines.filter(function (event) {
                return event.DivisionID === vm.product.sDivisionID
            })
            vm.product.sProductLineID = vm.product.ProductLineID
        }
    }
    function onChangeDivision() {
        if (vm.editForm) {
            vm.editForm.Division.$setDirty(true);
        }
        filterProductLines();
    }

    function onChangeProductLine() {
        if (vm.editForm) {
            vm.editForm.ProductLine.$setDirty(true);
        }
    }
    function onSubmit() {
        vm.errorMsg = null;
        let save;
        utilityService.showLoading();
        const request = {
            ProductCode: vm.product.ProductCode,
            Name: vm.product.Name,
            Description: vm.product.Description,
            ProductID: vm.product.ProductID,
            DivisionID: vm.product.sDivisionID,
            ProductLineID: vm.product.sProductLineID
        };
        if (vm.product.ProductID) {
            save = productsService.updateProduct(vm.product.ProductID, request);
        } else {
            save = productsService.createProduct(request);
        }

        save
            .then(function () {
                vm.editForm.$setPristine();
                vm.afterSubmit({ product: vm.product, window: window });

            })
            .catch(function (ex) {
                console.error(ex);
                if (ex.data && ex.data.ModelState) {
                    vm.modelState = ex.data.ModelState;
                } else {
                    alert(utilityService.getExceptionMessage(ex));
                }
            })
            .then(() => utilityService.hideLoading())
    }
}
